import React from 'react';
import { getRunStatusLabel } from '../simulation.model';
import * as _ from 'lodash';

export const RunStatusBadge = ({ status }) => (
    <span className={'sim-status ' + _.toLower(status)}>
        {getRunStatusLabel(status)}
    </span>
);
